var React = require('react');

function IconPenInline (props) {
    return React.createElement("path",props);
}

IconPenInline.defaultProps = {"d":"M0.057765478,45.1923345 C-0.0894335954,45.6866672 0.0493541024,46.2242888 0.420856526,46.5845651 C0.684412962,46.847092 1.04189643,46.9909233 1.41480074,46.9895269 C1.5353638,47.003491 1.65732874,47.003491 1.77789179,46.9895269 L9.4,44.914447 L2.09892596,37.6 L0.057765478,45.1923345 Z M45.9157806,4.51809053 L42.4808748,1.08309067 C41.0367935,-0.361030224 38.6938294,-0.361030224 37.2497481,1.08309067 L18.8813422,19.4519996 L18.8797977,19.4519996 L4.7,33.6321856 L13.3691215,42.3 L28.7860413,26.8811135 L28.7860413,26.8811135 L45.9157806,9.75090507 C47.3614065,8.30523966 47.3614065,5.96375594 45.9157806,4.51809053"};

module.exports = IconPenInline;

IconPenInline.default = IconPenInline;
